export const AccountType = {
  NORMAL: 1, // 普通
  TEMPORARY: 2, // 当座
  SAVING: 3, // 貯蓄
} as const satisfies Record<string, number>;
export type AccountType = (typeof AccountType)[keyof typeof AccountType];

export const ACCOUNT_NAME_MAX_LENGTH = 100;
export const ACCOUNT_NUMBER_MAX_LENGTH = 7;
export const BANK_CODE_MAX_LENGTH = 10;
export const BANK_NAME_MAX_LENGTH = 32;
export const BRANCH_CODE_MAX_LENGTH = 10;
export const BRANCH_NAME_MAX_LENGTH = 32;
